import type {
  CarFiltersListApiData,
  CarFiltersListApiResponses,
  CarRimBrandListApiData,
  CarRimBrandListApiResponses,
  CarTireCreateApiData,
  CarTireCreateApiResponses,
  CarTireQuoteItemTirePatchApiData,
  CarTireQuoteItemTirePatchApiResponses,
  FulfillmentIssueGetApiData,
  FulfillmentIssueGetApiResponses,
  FulfillmentIssueListApiData,
  FulfillmentIssueListApiResponses,
  FulfillmentIssuePatchApiData,
  FulfillmentIssuePatchApiResponses,
  InventoryOrderCreateApiData,
  InventoryOrderCreateApiResponses,
  InventoryOrderGetApiData,
  InventoryOrderGetApiResponses,
  InventoryOrderLineReceiveApiData,
  InventoryOrderLineReceiveApiResponses,
  InventoryOrderNoteAttachmentDeleteApiData,
  InventoryOrderNoteAttachmentDeleteApiResponses,
  InventoryOrderNoteAttachmentsBulkCreateApiData,
  InventoryOrderNoteAttachmentsBulkCreateApiResponses,
  InventoryOrderNoteCreateApiData,
  InventoryOrderNoteCreateApiResponses,
  InventoryOrderNoteDeleteApiData,
  InventoryOrderNoteDeleteApiResponses,
  InventoryOrderNoteListApiData,
  InventoryOrderNoteListApiResponses,
  InventoryOrderNotePatchApiData,
  InventoryOrderNotePatchApiResponses,
  InventoryOrderPatchApiData,
  InventoryOrderPatchApiResponses,
  RimInventoryFilterCountsApiData,
  RimInventoryFilterCountsApiResponses,
  RimInventoryGetApiData,
  RimInventoryGetApiResponses,
  RimInventoryListApiData,
  RimInventoryListApiResponses,
  ShopRimBrandListApiData,
  ShopRimBrandListApiResponses,
  ShopRimInventoryDimensionsListApiData,
  ShopRimInventoryDimensionsListApiResponses,
  ShopRimListApiData,
  ShopRimListApiResponses,
  ShopSupplierGetApiData,
  ShopSupplierGetApiResponses,
  ShopSupplierListApiData,
  ShopSupplierListApiResponses,
  ShopSupplierUpdateApiData,
  ShopSupplierUpdateApiResponses,
  ShopTireBrandGetApiData,
  ShopTireBrandGetApiResponses,
  ShopTireBrandListApiData,
  ShopTireBrandListApiResponses,
  ShopTireBrandPatchApiData,
  ShopTireBrandPatchApiResponses,
  ShopTireInventoryDimensionsListApiData,
  ShopTireInventoryDimensionsListApiResponses,
  SupplierBrandCategoryGetApiData,
  SupplierBrandCategoryGetApiResponses,
  SupplierBrandCategoryListApiData,
  SupplierBrandCategoryListApiResponses,
  SupplierBrandCategoryPatchApiData,
  SupplierBrandCategoryPatchApiResponses,
  SupplierWarehouseListApiData,
  SupplierWarehouseListApiResponses,
  TireInventoryCreateApiData,
  TireInventoryCreateApiResponses,
  TireInventoryFilterCountsApiData,
  TireInventoryFilterCountsApiResponses,
  TireInventoryGetApiData,
  TireInventoryGetApiResponses,
  TireInventoryListApiData,
  TireInventoryListApiResponses,
  TireInventorySupplierPromiseApiData,
  TireInventorySupplierPromiseApiResponses
} from '@navio/nsdk';

import { apiUrl, dataEndpoint, responseEndpoint } from '../defineResource';
import { noteAttachmentFilesFormData } from '../noteAttachmentFormData';

export const getTireInventoryUrls = {
  getPaginatedTireInventoryList: dataEndpoint<TireInventoryListApiData, TireInventoryListApiResponses>({
    getUrl: (queryParams) => apiUrl('shop/tire-inventory/', queryParams)
  }),
  getTireInventoryFilterCounts: dataEndpoint<TireInventoryFilterCountsApiData, TireInventoryFilterCountsApiResponses>({
    getUrl: (queryParams) => apiUrl('shop/tire-inventory/filter-counts/', queryParams)
  }),
  getTireInventoryListByIds: dataEndpoint<TireInventoryListApiData, TireInventoryListApiResponses>({
    getUrl: (queryParams) => apiUrl('shop/tire-inventory/', queryParams)
  }),
  getTireInventoryTireInfo: dataEndpoint<TireInventoryGetApiData, TireInventoryGetApiResponses>({
    getUrl: ({ pk, ...queryParams }) => apiUrl(`shop/tire-inventory/${pk}/`, queryParams)
  }),
  postTireInventorySupplierPromise: responseEndpoint<
    TireInventorySupplierPromiseApiData,
    TireInventorySupplierPromiseApiResponses
  >({
    getUrl: ({ pk, ...queryParams }) => apiUrl(`shop/tire-inventory/${pk}/supplier-promise/`, queryParams)
  }),
  getCarSpecificationTireFilters: dataEndpoint<CarFiltersListApiData, CarFiltersListApiResponses>({
    getUrl: () => apiUrl('cars/filter/tires/specifications/')
  }),
  getPaginatedTireInventoryDimensions: dataEndpoint<
    ShopTireInventoryDimensionsListApiData,
    ShopTireInventoryDimensionsListApiResponses
  >({
    getUrl: (queryParams) => apiUrl('shop/tire-inventory-dimensions/', queryParams)
  }),
  postTireToInventory: responseEndpoint<TireInventoryCreateApiData, TireInventoryCreateApiResponses>({
    getUrl: () => apiUrl('shop/tire-inventory/'),
    getBody: (data) => data
  }),
  getPaginatedTireBrands: dataEndpoint<ShopTireBrandListApiData, ShopTireBrandListApiResponses>({
    getUrl: (queryParams) => apiUrl('shop/tire-brands/', queryParams)
  }),
  getTireBrand: dataEndpoint<ShopTireBrandGetApiData, ShopTireBrandGetApiResponses>({
    getUrl: ({ pk }) => apiUrl(`shop/tire-brands/${pk}/`)
  }),
  patchTireBrand: responseEndpoint<ShopTireBrandPatchApiData, ShopTireBrandPatchApiResponses>({
    getUrl: ({ pk }) => apiUrl(`shop/tire-brands/${pk}/`),
    getHeaders: () => ({
      'Content-Type': 'multipart/form-data'
    }),
    getBody: ({ pk: _, ...data }) => data,
    skipBodyTransformation: true
  }),
  postCreateTire: responseEndpoint<CarTireCreateApiData, CarTireCreateApiResponses>({
    getUrl: () => apiUrl('shop/tires/'),
    getBody: (data) => data
  }),
  getTireShopSuppliers: dataEndpoint<ShopSupplierListApiData, ShopSupplierListApiResponses>({
    getUrl: (queryParams) => apiUrl('shop/suppliers/', queryParams)
  }),
  getSupplierWarehouses: dataEndpoint<SupplierWarehouseListApiData, SupplierWarehouseListApiResponses>({
    getUrl: (queryParams) => apiUrl('shop/supplier-warehouses/', queryParams)
  }),
  postOrderInventory: responseEndpoint<InventoryOrderCreateApiData, InventoryOrderCreateApiResponses>({
    getUrl: () => apiUrl('shop/inventory-orders/'),
    getBody: (data) => data
  }),
  patchInventoryOrderToQuoteItemTire: responseEndpoint<
    CarTireQuoteItemTirePatchApiData,
    CarTireQuoteItemTirePatchApiResponses
  >({
    getUrl: ({ pk }) => apiUrl(`car-tire-quote-item-tire/${pk}/`),
    getBody: ({ pk: _, ...body }) => body
  }),
  getInventoryOrder: dataEndpoint<InventoryOrderGetApiData, InventoryOrderGetApiResponses>({
    getUrl: ({ pk }) => apiUrl(`shop/inventory-order/${pk}/`)
  }),
  patchInventoryOrder: responseEndpoint<InventoryOrderPatchApiData, InventoryOrderPatchApiResponses>({
    getUrl: ({ pk }) => apiUrl(`shop/inventory-order/${pk}/`),
    getBody: ({ pk: _, ...data }) => data
  }),
  postInventoryOrderLineReceive: responseEndpoint<
    InventoryOrderLineReceiveApiData,
    InventoryOrderLineReceiveApiResponses
  >({
    getUrl: ({ pk }) => apiUrl(`shop/inventory-order-lines/${pk}/receive/`),
    getBody: ({ pk: _, ...body }) => body
  }),
  getPaginatedRimInventoryDimensions: dataEndpoint<
    ShopRimInventoryDimensionsListApiData,
    ShopRimInventoryDimensionsListApiResponses
  >({
    getUrl: (queryParams) => apiUrl('shop/rim-inventory-dimensions/', queryParams)
  }),
  getPaginatedRimInventoryList: dataEndpoint<RimInventoryListApiData, RimInventoryListApiResponses>({
    getUrl: (queryParams) => apiUrl('shop/rim-inventory/', queryParams)
  }),
  getRimInventoryFilterCounts: dataEndpoint<RimInventoryFilterCountsApiData, RimInventoryFilterCountsApiResponses>({
    getUrl: (queryParams) => apiUrl('shop/rim-inventory/filter-counts/', queryParams)
  }),
  getRimInventory: dataEndpoint<RimInventoryGetApiData, RimInventoryGetApiResponses>({
    getUrl: ({ pk }) => apiUrl(`shop/rim-inventory/${pk}/`)
  }),
  getPaginatedRimBrands: dataEndpoint<CarRimBrandListApiData, CarRimBrandListApiResponses>({
    getUrl: (queryParams) => apiUrl('car-rim-brands/', queryParams)
  }),
  getPaginatedShopRimBrands: dataEndpoint<ShopRimBrandListApiData, ShopRimBrandListApiResponses>({
    getUrl: (queryParams) => apiUrl('shop/rim-brands/', queryParams)
  }),
  getPaginatedShopRims: dataEndpoint<ShopRimListApiData, ShopRimListApiResponses>({
    getUrl: (queryParams) => apiUrl('shop/rims/', queryParams)
  }),
  getPaginatedSuppliers: dataEndpoint<ShopSupplierListApiData, ShopSupplierListApiResponses>({
    getUrl: (queryParams) => apiUrl('shop/suppliers/', queryParams)
  }),
  getSupplier: dataEndpoint<ShopSupplierGetApiData, ShopSupplierGetApiResponses>({
    getUrl: ({ pk }) => apiUrl(`shop/suppliers/${pk}/`)
  }),
  patchSupplier: responseEndpoint<ShopSupplierUpdateApiData, ShopSupplierUpdateApiResponses>({
    getUrl: ({ pk }) => apiUrl(`shop/suppliers/${pk}/`),
    getHeaders: () => ({
      'Content-Type': 'multipart/form-data'
    }),
    getBody: ({ name, types, logo }) => {
      const formData = new FormData();
      if (name != null) {
        formData.append('name', name);
      }
      if (types) {
        for (const type of types) {
          formData.append('types', type);
        }
      }
      if (logo) {
        formData.append('logo', logo);
      }
      return formData;
    },
    skipBodyTransformation: true
  }),
  getInventoryOrderNotes: dataEndpoint<InventoryOrderNoteListApiData, InventoryOrderNoteListApiResponses>({
    getUrl: ({ inventoryOrderId, ...queryParams }) =>
      apiUrl('inventory-order-notes/', { inventoryOrderId, ...queryParams })
  }),
  postInventoryOrderNote: responseEndpoint<InventoryOrderNoteCreateApiData, InventoryOrderNoteCreateApiResponses>({
    getUrl: () => apiUrl('inventory-order-notes/'),
    getBody: (data) => data
  }),
  patchInventoryOrderNote: responseEndpoint<InventoryOrderNotePatchApiData, InventoryOrderNotePatchApiResponses>({
    getUrl: ({ inventoryOrderNoteId }) => apiUrl(`inventory-order-notes/${inventoryOrderNoteId}/`),
    getBody: ({ inventoryOrderNoteId: _, ...body }) => body
  }),
  deleteInventoryOrderNote: dataEndpoint<InventoryOrderNoteDeleteApiData, InventoryOrderNoteDeleteApiResponses>({
    getUrl: ({ inventoryOrderNoteId }) => apiUrl(`inventory-order-notes/${inventoryOrderNoteId}/`)
  }),
  postInventoryOrderNoteAttachmentsBulk: responseEndpoint<
    InventoryOrderNoteAttachmentsBulkCreateApiData,
    InventoryOrderNoteAttachmentsBulkCreateApiResponses
  >({
    getUrl: ({ inventoryOrderNoteId }) => apiUrl(`inventory-order-notes/${inventoryOrderNoteId}/attachments/bulk/`),
    getHeaders: () => ({ 'Content-Type': 'multipart/form-data' }),
    getBody: ({ files }) => noteAttachmentFilesFormData(files),
    skipBodyTransformation: true
  }),
  deleteInventoryOrderNoteAttachment: dataEndpoint<
    InventoryOrderNoteAttachmentDeleteApiData,
    InventoryOrderNoteAttachmentDeleteApiResponses
  >({
    getUrl: ({ inventoryOrderNoteId, attachmentId }) =>
      apiUrl(`inventory-order-notes/${inventoryOrderNoteId}/attachments/${attachmentId}/`)
  }),
  getPaginatedFulfillmentIssues: dataEndpoint<FulfillmentIssueListApiData, FulfillmentIssueListApiResponses>({
    getUrl: (queryParams) => apiUrl('shop/fulfillment-issues/', queryParams)
  }),
  getFulfillmentIssue: dataEndpoint<FulfillmentIssueGetApiData, FulfillmentIssueGetApiResponses>({
    getUrl: ({ fulfillmentIssueId }) => apiUrl(`shop/fulfillment-issues/${fulfillmentIssueId}/`)
  }),
  patchFulfillmentIssue: responseEndpoint<FulfillmentIssuePatchApiData, FulfillmentIssuePatchApiResponses>({
    getUrl: ({ fulfillmentIssueId }) => apiUrl(`shop/fulfillment-issues/${fulfillmentIssueId}/`),
    getBody: ({ fulfillmentIssueId: _, ...body }) => body
  }),
  getPaginatedSupplierBrandCategories: dataEndpoint<
    SupplierBrandCategoryListApiData,
    SupplierBrandCategoryListApiResponses
  >({
    getUrl: (queryParams) => apiUrl('shop/supplier-brand-categories/', queryParams)
  }),
  getSupplierBrandCategory: dataEndpoint<SupplierBrandCategoryGetApiData, SupplierBrandCategoryGetApiResponses>({
    getUrl: ({ supplierBrandCategoryId }) => apiUrl(`shop/supplier-brand-categories/${supplierBrandCategoryId}/`)
  }),
  patchSupplierBrandCategory: responseEndpoint<
    SupplierBrandCategoryPatchApiData,
    SupplierBrandCategoryPatchApiResponses
  >({
    getUrl: ({ supplierBrandCategoryId }) => apiUrl(`shop/supplier-brand-categories/${supplierBrandCategoryId}/`),
    getBody: ({ supplierBrandCategoryId: _, ...body }) => body
  })
};
